import { injectable } from 'inversify';
import { ProjectDto } from '../queries/GetProjectQuery';
import { IPaginatedResult } from '@swoft/core';

@injectable()
export class ProjectQueryService {
    async getProject(projectId: string): Promise<ProjectDto | null> {
        // This is a dummy implementation for now
        console.warn(`ProjectQueryService: Returning dummy data for project ID: ${projectId}`);
        return {
            id: projectId,
            name: `Dummy Project ${projectId}`,
            description: 'This is a dummy project description.',
            domainId: 'dummy-domain',
            metadata: {},
            createdAt: new Date(),
            updatedAt: new Date(),
        };
    }

    async listProjects(query: any): Promise<IPaginatedResult<ProjectDto>> {
        console.warn(`ProjectQueryService: Returning dummy data for list projects query: ${JSON.stringify(query)}`);
        const dummyProjects: ProjectDto[] = [
            {
                id: 'dummy-project-1',
                name: 'Dummy Project 1',
                description: 'First dummy project.',
                domainId: 'dummy-domain',
                metadata: {},
                createdAt: new Date(),
                updatedAt: new Date(),
            },
            {
                id: 'dummy-project-2',
                name: 'Dummy Project 2',
                description: 'Second dummy project.',
                domainId: 'dummy-domain',
                metadata: {},
                createdAt: new Date(),
                updatedAt: new Date(),
            },
        ];

        return {
            items: dummyProjects,
            totalCount: dummyProjects.length,
            page: query.page || 1,
            pageSize: query.pageSize || dummyProjects.length,
            totalPages: 1,
            hasNextPage: false,
            hasPreviousPage: false,
        } as IPaginatedResult<ProjectDto>;
    }
}
